var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.30801 6.66667L8.81634 6.175L7.64134 5H3.33301V15H16.6663V6.66667H9.30801ZM15.833 13.3333V14.1667H9.16634V13.3333C9.16634 12.225 11.3913 11.6667 12.4997 11.6667C13.608 11.6667 15.833 12.225 15.833 13.3333ZM12.4997 7.5C13.4163 7.5 14.1663 8.25 14.1663 9.16667C14.1663 10.0833 13.4163 10.8333 12.4997 10.8333C11.583 10.8333 10.833 10.0833 10.833 9.16667C10.833 8.25 11.583 7.5 12.4997 7.5Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 4.99998H10.0003L8.33366 3.33331H3.33366C2.41699 3.33331 1.67533 4.08331 1.67533 4.99998L1.66699 15C1.66699 15.9166 2.41699 16.6666 3.33366 16.6666H16.667C17.5837 16.6666 18.3337 15.9166 18.3337 15V6.66665C18.3337 5.74998 17.5837 4.99998 16.667 4.99998ZM16.667 15H3.33366V4.99998H7.64199L9.30866 6.66665H16.667V15ZM12.5003 10.8333C13.417 10.8333 14.167 10.0833 14.167 9.16665C14.167 8.24998 13.417 7.49998 12.5003 7.49998C11.5837 7.49998 10.8337 8.24998 10.8337 9.16665C10.8337 10.0833 11.5837 10.8333 12.5003 10.8333ZM9.16699 13.3333V14.1666H15.8337V13.3333C15.8337 12.225 13.6087 11.6666 12.5003 11.6666C11.392 11.6666 9.16699 12.225 9.16699 13.3333Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.d173be56c2e1e42ee505f06efba82b96.svg";
export { ForwardRef as ReactComponent };